export const TITLES = {
  LOGIN: "WELCOME TO THE FUTURE OF CREATIVITY",
  LOGOUT: "YOU'RE NOW LOGGED OUT",
};

export const DESCRIPTION = {
  LOGOUT: {
    MAIN: "Come back any time to create your next big concept or whip up some campaign copy.",
    BOLD: "We're ready for you.",
    SECONDARY: "Didn't mean to log out? No worries.",
  },
};

export const BUTTON_TEXT = "SSO LOGIN";

export const ERROR_TEXT = "error";

export const ERROR_MESSAGE = "We are having trouble logging you in. Please try again.";

export const FOOTER =
  "You have reached a private proprietary software platform of Mondelez International. Do not attempt to access this platform unless you have been explicitly authorized to do so by Mondelez International. Access by individuals who have not been authorized is strictly forbidden and subject to prosecution.";

export const LOGOUT_TEXT = "logOut";
export const LOGIN_TEXT = "login";

export const ERROR_UNAUTH_TEXT = "unauthorized";

export const ERROR_UNAUTH_MESSAGE = "Sorry, you are not authorized to access AIDA.";
